import { RESOURCES, RESOURCE_LABELS, type ResourceAmount } from '@bienenkampf/shared';
import { Progress } from '@bienenkampf/ui';
import { formatNumber } from '../lib/time.js';
import type { HiveView } from './types.js';

const ICON: Record<keyof ResourceAmount, string> = { nectar: '🍯', pollen: '🌼', wax: '🕯' };

/** Ressourcen zum Zeitpunkt `resourcesAt` + Rate × verstrichene Zeit, gekappt am Lager. Der Server bleibt autoritativ. */
export function liveResources(view: HiveView, now: Date): ResourceAmount {
  const minutes = Math.max(0, (now.getTime() - view.resourcesAt.getTime()) / 60_000);
  const out = { ...view.resources };
  for (const r of RESOURCES) {
    const next = view.resources[r] + view.ratesPerMinute[r] * minutes;
    out[r] = next > view.capacity[r] ? Math.max(view.resources[r], view.capacity[r]) : next;
  }
  return out;
}

export function ResourceBar({ view, now }: { view: HiveView; now: Date }) {
  const live = liveResources(view, now);
  return (
    <div className="grid grid-cols-3 gap-2">
      {RESOURCES.map((r) => {
        const full = live[r] >= view.capacity[r];
        return (
          <div key={r} className="rounded-xl border border-stone-800 bg-stone-950/40 p-3">
            <div className="flex items-center justify-between text-xs text-stone-400">
              <span>
                {ICON[r]} {RESOURCE_LABELS[r]}
              </span>
              <span title="pro Stunde">+{formatNumber(view.ratesPerMinute[r] * 60)}/h</span>
            </div>
            <div
              className={`mt-1 text-lg font-semibold tabular-nums ${full ? 'text-red-300' : ''}`}
            >
              {formatNumber(live[r])}
              <span className="text-xs font-normal text-stone-500">
                {' '}
                / {formatNumber(view.capacity[r])}
              </span>
            </div>
            <Progress value={live[r] / view.capacity[r]} className="mt-2" />
          </div>
        );
      })}
    </div>
  );
}
